<template>
  <div class="filter_small_screen mt-2">
    <collapse-header title_img="filter" title="بحث بحسب">
      {{ selectedType }}
      <form-select
        class="w-25"
        label="النوع"
        :dir="'rtl'"
        :getOptionLabel="(x) => x.title_ar"
        :reduce="(x) => x.id"
        v-model="selectedType"
        ep="v2/guest/selects/event-types"
        id="small_event_types"
      />
      <form-autocomplete
        class="mx-25"
        label="المنظمة"
        :dir="'rtl'"
        :getOptionLabel="(x) => x.name_ar"
        :reduce="(x) => x.id"
        v-model="selectedOrg"
        ep="v2/guest/filter-name"
        id="ngos"
        filterKey="name"
        placeholder="ابدأ بالكتابة للبحث"
        dataPath="data.current_data"
      />
      <b-form-group class="mb-2" label="التاريخ">
        <b-form-datepicker
          placeholder=""
          selected-variant="primary"
          @context="onContext"
          v-model="selectedDate"
          locale="ar-SY"
        />
      </b-form-group>
      <div class="px-1 w-100 d-flex justify-content-between">
        <b-button variant="info" class="mx-1" @click="fliterByParam()"
          >بحث</b-button
        >
        <b-button variant="primary" @click="unFilter()">إلغاء بحث</b-button>
      </div>
    </collapse-header>
  </div>
</template>
<script>
import CollapseHeader from "@core/components/app-collapse/CollapseHeader.vue";
import FormSelect from "@/components/form-select";
import formAutocomplete from "@/components/form-autocomplete";
import formSelect from "@/components/form-select";
import { BFormGroup, BFormDatepicker, BButton } from "bootstrap-vue";
import { mapGetters } from "vuex";

export default {
  components: {
    CollapseHeader,
    FormSelect,
    formAutocomplete,
    formSelect,
    BFormGroup,
    BFormDatepicker,
    BButton,
  },
  data() {
    return {
      selectedDate: "",
      selectedOrg: "",
      selectedType: "",
    };
  },
  methods: {
    onContext(ctx) {
      this.value = ctx.selectedFormatted;
    },
    fliterByParam() {
      this.$store.dispatch("NgoHome/activites_/getSlids", {
        ngo_id: this.selectedOrg,
        event_type_id: this.selectedType,
        time: this.selectedDate,
      });
    },
    unFilter() {
      this.selectedDate = "";
      this.selectedOrg = "";
      this.selectedType = "";
      this.fliterByParam();
    },
  },
  computed: {
  },
};
</script>

<style lang="scss">
.filter_small_screen {
  display: none;
}

@media (max-width: 1030px) {
  .filter_small_screen {
    display: block;
  }
}
</style>
